module.exports = __webpack_public_path__ + "img/course75.23b8b3cc.png";